import { ProductRequestApprovalStatus } from "../enums/product-request-approval-status";
import { ProductRequest } from "../models/ProductRequest";

export function getApprovalNotRequiredProductRequestItemCount(productRequest: ProductRequest): number {
    return productRequest.items.filter(item => item.approvalStatus === ProductRequestApprovalStatus.NOT_REQUIRED).length;
}